import { Box, Flex } from '@chakra-ui/layout';
import { useDisclosure, Button } from '@chakra-ui/react';
import React from 'react';

import { ExpensesTable } from './ExpensesTable';
import { Icon } from 'packages/common-frontend/components/icons';
import { Typography } from 'packages/common-frontend/components/Typography';
import { AddFeeModal } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/expense-mechanics/AddFeeModal';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

export const ExpensesSummary = () => {
  const hasLiabilityAccounts = useCreditAgreementStore((store) =>
    Boolean(store.creditAgreement?.liabilityAccounts?.length),
  );
  const modalControls = useDisclosure();

  return (
    <Flex direction="column" gap="1.5rem">
      <Flex justifyContent="space-between">
        <Box>
          <Typography variant="page-title">Expenses & Fees</Typography>
          <Typography variant="base-muted">
            Defines the configuration of fees included in the waterfall,
            including their structure, payment rules, and allocation to ensure
            proper application and administration throughout the loan lifecycle.
            Select &apos;Review Changes&apos; to submit for approval.
          </Typography>
        </Box>
        <Button
          colorScheme="v2-aurora"
          flexShrink={0}
          leftIcon={<Icon icon="plus" />}
          onClick={modalControls.onOpen}
          variant="outline"
        >
          Add Fee
        </Button>
        <AddFeeModal modalControls={modalControls} />
      </Flex>
      {hasLiabilityAccounts && <ExpensesTable />}
    </Flex>
  );
};
